import { Component,ViewChild ,ElementRef  } from '@angular/core';
import {CdkDragDrop, moveItemInArray, transferArrayItem,copyArrayItem} from '@angular/cdk/drag-drop';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { ImageCroppedEvent, LoadedImage ,Dimensions,ImageTransform} from "ngx-image-cropper";
import { DomSanitizer} from '@angular/platform-browser';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { getLocalJSON } from '../../_helpers/storage.util';

declare var $:any;

@Component({
  selector: 'app-createprogram',
  templateUrl: './createprogram.component.html',
  styleUrls: ['./createprogram.component.scss']
})
export class CreateprogramComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public selectedFile: any = "";
  public userUpdatedImage: any;
  public imagePath: any;
  public showView:boolean=true;
  imgURL: any = "";
  public message: any;
  public videoAlbum:any=[];
  public iamgeAlbum:any=[];
  public docAlbum:any=[];
  public ViewType:any=1;
  public alldataAlbum:any=[];
  public AlbumData:any=[];
  public AddAlbumData:any=[{}];
  public currentUrl:any=this.router.url;
  public dataDetail:any=[];
  public search:any='';
  public cdkView:boolean= false;
  public status:any='';
  public showSearch:boolean=false;
  public viewKey:any=1;
  public Weekarray:any=[{id:'pills_1',name:'Week 1',text_id:'WeekTab1',dis:''},
    {id:'pills_2',name:'Week 2',text_id:'WeekTab2',dis:'disabled'},
    {id:'pills_3',name:'Week 3',text_id:'WeekTab3',dis:'disabled'},
    {id:'pills_4',name:'Week 4',text_id:'WeekTab4',dis:'disabled'},
    {id:'pills_5',name:'Week 5',text_id:'WeekTab5',dis:'disabled'},
    {id:'pills_6',name:'Week 6',text_id:'WeekTab6',dis:'disabled'},
    {id:'pills_7',name:'Week 7',text_id:'WeekTab7',dis:'disabled'},
    {id:'pills_8',name:'Week 8',text_id:'WeekTab8',dis:'disabled'},
    {id:'pills_9',name:'Week 9',text_id:'WeekTab9',dis:'disabled'},
    {id:'pills_10',name:'Week 10',text_id:'WeekTab10',dis:'disabled'},
    {id:'pills_11',name:'Week 11',text_id:'WeekTab11',dis:'disabled'},
    {id:'pills_12',name:'Week 12',text_id:'WeekTab12',dis:'disabled'},
    {id:'pills_13',name:'Week 13',text_id:'WeekTab13',dis:'disabled'},
    {id:'pills_14',name:'Week 14',text_id:'WeekTab14',dis:'disabled'},
    {id:'pills_15',name:'Week 15',text_id:'WeekTab15',dis:'disabled'},
    {id:'pills_16',name:'Week 16',text_id:'WeekTab16',dis:'disabled'},
    {id:'pills_17',name:'Week 17',text_id:'WeekTab17',dis:'disabled'},
    {id:'pills_18',name:'Week 18',text_id:'WeekTab18',dis:'disabled'},
    {id:'pills_19',name:'Week 19',text_id:'WeekTab19',dis:'disabled'},
    {id:'pills_20',name:'Week 20',text_id:'WeekTab20',dis:'disabled'},
    {id:'pills_21',name:'Week 21',text_id:'WeekTab21',dis:'disabled'},
    {id:'pills_22',name:'Week 22',text_id:'WeekTab22',dis:'disabled'},
    {id:'pills_23',name:'Week 23',text_id:'WeekTab23',dis:'disabled'},
    {id:'pills_24',name:'Week 24',text_id:'WeekTab24',dis:'disabled'},
    {id:'pills_25',name:'Week 25',text_id:'WeekTab25',dis:'disabled'},
    {id:'pills_26',name:'Week 26',text_id:'WeekTab26',dis:'disabled'},
    {id:'pills_27',name:'Week 27',text_id:'WeekTab27',dis:'disabled'},
    {id:'pills_28',name:'Week 28',text_id:'WeekTab28',dis:'disabled'},
    {id:'pills_29',name:'Week 29',text_id:'WeekTab29',dis:'disabled'},
    {id:'pills_30',name:'Week 30',text_id:'WeekTab30',dis:'disabled'},
    {id:'pills_31',name:'Week 31',text_id:'WeekTab31',dis:'disabled'},
    {id:'pills_32',name:'Week 32',text_id:'WeekTab32',dis:'disabled'},
    {id:'pills_33',name:'Week 33',text_id:'WeekTab33',dis:'disabled'},
    {id:'pills_34',name:'Week 34',text_id:'WeekTab34',dis:'disabled'},
    {id:'pills_35',name:'Week 35',text_id:'WeekTab35',dis:'disabled'},
    {id:'pills_36',name:'Week 36',text_id:'WeekTab36',dis:'disabled'},
    {id:'pills_37',name:'Week 37',text_id:'WeekTab37',dis:'disabled'},
    {id:'pills_38',name:'Week 38',text_id:'WeekTab38',dis:'disabled'},
    {id:'pills_39',name:'Week 39',text_id:'WeekTab39',dis:'disabled'},
    {id:'pills_40',name:'Week 40',text_id:'WeekTab40',dis:'disabled'},
    {id:'pills_41',name:'Week 41',text_id:'WeekTab41',dis:'disabled'},
    {id:'pills_42',name:'Week 42',text_id:'WeekTab42',dis:'disabled'},
    {id:'pills_43',name:'Week 43',text_id:'WeekTab43',dis:'disabled'},
    {id:'pills_44',name:'Week 44',text_id:'WeekTab44',dis:'disabled'},
    {id:'pills_45',name:'Week 45',text_id:'WeekTab45',dis:'disabled'},
    {id:'pills_46',name:'Week 46',text_id:'WeekTab46',dis:'disabled'},
    {id:'pills_47',name:'Week 47',text_id:'WeekTab47',dis:'disabled'},
    {id:'pills_48',name:'Week 48',text_id:'WeekTab48',dis:'disabled'},
    {id:'pills_49',name:'Week 49',text_id:'WeekTab49',dis:'disabled'},
    {id:'pills_50',name:'Week 50',text_id:'WeekTab50',dis:'disabled'},
    {id:'pills_51',name:'Week 51',text_id:'WeekTab51',dis:'disabled'},
    {id:'pills_52',name:'Week 52',text_id:'WeekTab52',dis:'disabled'},
    {id:'pills_53',name:'Week 53',text_id:'WeekTab53',dis:'disabled'}
  ];
  public DayArray:any=[{id:'pills_day_1',name:'Day 1',text_id:'DayTab1', class:'active'},
    {id:'pills_day_2',name:'Day 2',text_id:'DayTab2',class:'' },
    {id:'pills_day_3',name:'Day 3',text_id:'DayTab3' ,class:''},
    {id:'pills_day_4',name:'Day 4',text_id:'DayTab4' ,class:''},
    {id:'pills_day_5',name:'Day 5',text_id:'DayTab5' ,class:''},
    {id:'pills_day_6',name:'Day 6',text_id:'DayTab6' ,class:''},
    {id:'pills_day_7',name:'Day 7',text_id:'DayTab7' ,class:''}
  ];
  public collectDataArray:any=[
    {id:1,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:2,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:3,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:4,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:5,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:6,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},  
    {id:7,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:8,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:9,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:10,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:11,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:12,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:13,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:14,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:15,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:16,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:17,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:18,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:19,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:20,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:21,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:22,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:23,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:24,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:25,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:26,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:27,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:28,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:29,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:30,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:31,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:32,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:33,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:34,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:35,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:36,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:37,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:38,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:39,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:40,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:41,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:42,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:43,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:44,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:45,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:46,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:47,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:48,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:49,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:50,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:51,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:52,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
    {id:53,week:{day:[{id:1,data:[]},{id:2,data:[]},{id:3,data:[]},{id:4,data:[]},{id:5,data:[]},{id:6,data:[]},{id:7,data:[]}]}},
  ];
  public dropdownSettings: IDropdownSettings;

  public loginDetail:any =[];
  public weeknumber:any=1;
  public daynumber:any=1;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedImage1: any = "";
  canvasRotation = 0;
  rotation?: number;
  translateH = 0;
  translateV = 0;
  scale = 1;
  aspectRatio = 4 / 3;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {
    translateUnit: 'px'
  };
  imageURL?: string;
  allowMoveImage = false;
  hidden = false;

  public programType:any='';
  public demographicList:any=[];
  public LevelLIst:any=[];
  public dietList:any=[];
  public genderList:any=[];

  public TypeList:any=[];
  public allmasterData:any={};
  public primaryList:any=[];
  public sprimaryList:any=[];
  public typeSelected:any=[];
  public typename:any='';
  public categorySelected:any=[];
  public categoryname:any='';
  public scategorySelected:any=[];
  public scategoryname:any='';
  public d_otherSelection:any='';
  public t_otherSelection:any='';
  public s_otherSelection:any='';
  public amount_max:any=1000;
  public amount_min:any=10;

  // todo = ['Get to work', 'Pick up groceries', 'Go home', 'Fall asleep'];
  // done = ['Get up', 'Brush teeth', 'Take a shower', 'Check e-mail', 'Walk dog'];


  programData = new FormGroup({
    albumName:new FormControl('',Validators.compose([
      Validators.required,Validators.maxLength(35) ])),
    types: new FormControl('', Validators.compose([
      Validators.required])),
    price:new FormControl('', Validators.compose([Validators.required,Validators.min(this.amount_min),Validators.max(this.amount_max)])),
    description:new FormControl('',Validators.compose([
      Validators.required, Validators.maxLength(140)  ])),
    demographic:new FormControl('',Validators.compose([
      Validators.required])),
    level:new FormControl(''),
    diet:new FormControl(''), 
    type:new FormControl(''),  
    category:new FormControl(''), 
    scategory:new FormControl(''), 
    gender:new FormControl(''), 
    d_others:new FormControl(''),
    s_others:new FormControl(''),
    t_others:new FormControl(''),    
 
  })
  
   get f() { return this.programData.controls; }

   constructor(private sanitizer: DomSanitizer,private el: ElementRef,public router: Router, public service: GlobalService) {
   var self=this;
    this.getAllMasterData();
    this.loginDetail = getLocalJSON('grw_login');
    if(this.loginDetail.userCurrency !='' && this.loginDetail.userCurrency !='AUD'){
      self.amount_min= self.service.exchangeCurrency(1,'AUD',10);
      self.amount_max= self.service.exchangeCurrency(1,'AUD',1000);
    }
    if (this.currentUrl == '/edit-program') {
      var js = getLocalJSON('grw_program')
      this.programType=js.category_type;
      this.getDetail1();
    } else {
      this.dataDetail.gender='';
    }
   }

   ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      limitSelection: 3,
    };   
  }

  getDetail1(){
    this.videoAlbum = [];
    this.iamgeAlbum = [];
    this.docAlbum = [];
    this.alldataAlbum = [];
    this.AlbumData = [];
    this.loading=true;
    var ss:any='';
    if(this.programType ==3){
      ss='';
    } else {
      ss= '?category_type='+this.programType;
    }
    const url = "/get-program-video-list"+ss; 
    var detail:any={
      "search": this.search,
      "post_type": '',
    }
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1) {
        if(response.data.length !=0){
          var self =this;
          response.data.filter((el:any)=>{
            if(el.post_type==1){
              self.videoAlbum.push(el);
            }
            if(el.post_type==2){
              self.iamgeAlbum.push(el);
            }
            if(el.post_type==3){
              self.docAlbum.push(el);
            }
            if(this.ViewType==1){
              self.AlbumData= self.videoAlbum;
            }
            if(this.ViewType==2){
              self.AlbumData= self.iamgeAlbum;
            }
            if(this.ViewType==3){
              self.AlbumData= self.docAlbum;
            }
            self.alldataAlbum.push(el);
          })         
        }
      } else {
          this.cdkView = true;
          this.videoAlbum = [];
          this.iamgeAlbum = [];
          this.docAlbum = [];
          this.alldataAlbum = [];
          this.AlbumData = [];
      }
      if(this.currentUrl=='/edit-program') {
        this.getalbumDetail();
      } else {
        this.cdkView = true;
      }
      this.loading=false;
    }), (error) => { this.loading =false; });
  }

  getDetail(type:any){
    var detail:any=[];
    if(type==1){
      detail =this.videoAlbum;
    }
    if(type==2){
      detail =this.iamgeAlbum;
    }
    if(type==3){
      detail =this.docAlbum;
    }
    this.AlbumData = detail;
    this.viewKey=type;
  }

  drop(event:any) {
    var jj:any=[];  
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else { 
      let idx = 1; 
      if(this.AddAlbumData.length !=0 ){
        this.AddAlbumData.filter((el:any)=>{
          if(el._id==undefined){
            return;
          }
          if(el._id ==event.previousContainer.data[event.previousIndex]._id){
            idx=0;
          }
      })
      }
      // let idx = this.AddAlbumData.map((e:any) => e._id).indexOf(event.previousContainer.data[event.previousIndex]._id);
      // let idx= event.container.data.indexOf(event.previousContainer.data[event.previousIndex]);
      if(idx == 0){
        return;
      }
      var jj:any=[],count=0; 
      if(event.previousContainer.data[0]._id!=undefined && event.previousContainer.data[0]._id!=null ){
      copyArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      ); 
      }
    }
    if(this.AddAlbumData.length !=0){
      var self=this ,count=1,rs=0;
      this.collectDataArray.filter((el:any)=>{
        if(el.id == self.weeknumber){
          el.week.day.filter((ell:any)=>{
            if(ell.id ==self.daynumber){
             ell.data=[];
            }
          })
        }
      })
      this.AddAlbumData.filter((eld:any)=>{
        if(eld._id==undefined){           
        } else {
          jj.push (eld);
          self.collectDataArray.filter((el:any)=>{
            if(el.id == self.weeknumber){
              el.week.day.filter((ell:any)=>{
                if(ell.id ==self.daynumber){
                  ell.data.push({_id:eld._id,order_number:count,alldata:eld});
                  count=count+1;
                }
              })
            }
          })
        }
      })
      if(jj.length !=0){
        this.AddAlbumData =jj; 
      } else {
        this.AddAlbumData =[{}]; 
      } 
    } else {
      var self=this;
      this.collectDataArray.filter((el:any)=>{
        if(el.id == self.weeknumber){
          el.week.day.filter((ell:any)=>{
            if(ell.id ==self.daynumber){
             ell.data=[];
            }
          })
        }
      })
      this.AddAlbumData =[{}]; 
    }
    this.collectDataArray[0].week.day.filter((el:any)=>{
      if(el.data.length !=0){
        if(self.weeknumber==1){
          this.Weekarray[self.weeknumber].dis='';
        }
      }     
    }) 
    this.collectDataArray.filter((el:any)=>{
      if(el.id == self.weeknumber){
        el.week.day.filter((ell:any)=>{
          if(ell.data.length !=0){
            this.Weekarray[self.weeknumber].dis='';
            return;
          }
        })
      }
    })   
  }

  exited1(id:any) {
    var mm =  this.AddAlbumData;
    var ss:any=[];
    mm.filter((el:any)=>{
      if(el._id !=id){
        ss.push(el);
      }
    })
    if(ss.length ==0){
      this.AddAlbumData =[{}];      
    } else {
      this.AddAlbumData =ss;
    }
    var self=this,counts=1;
    this.collectDataArray.filter((el:any)=>{
      if(el.id == self.weeknumber){
        el.week.day.filter((ell:any)=>{
          if(ell.id ==self.daynumber){
           ell.data=ss;
          }
        })
      }
    }) 
    this.collectDataArray.filter((el:any)=>{
    el.week.day.filter((ell:any)=>{
      if(ell.data.length !=0){
        counts=0;
        return false;
      }           
    })
    if( counts==1){
      this.Weekarray[self.weeknumber].dis='disabled';
      return false;
    }
  }) 
    
  }

  exited(event: any) {
    const currentidx = event.container.data.findindex(
      (f: any) => f.id === event.item.data.id
    );
    this.AlbumData.splice(currentidx + 1, 0, {
      ...event.item.data,
      temp: true,
    });
  }

  entered() {
    this.AlbumData = this.AlbumData.filter((f: any) => !f.temp);
  }

  Onsubmit(type:any){
    this.submitted = true; 
    var url="" ,self=this;
    let formdata = new FormData();   
      let userdetail:any = this.programData;   
      if(this.croppedImage == ''){
         this.service.dangerAlert('Cover Image is Required');
        return
      } else {
        if (this.croppedImage1 != "") {
          const fileObject = this.service.dataURLtoFile(
            this.croppedImage1,
            "post.png"
          );
          formdata.append("program_image", fileObject);
        }
      } 
      var kk:any=[]; var count=1;
      for(var i=0;i<this.weeknumber;i++){
        this.collectDataArray[i].week.day.filter((el:any)=>{
          if(el.data.length!=0){ 
            el.data.filter((ell:any)=>{
              kk.push ({"post_id": ell._id, "order": ell.order_number,"week": i+1, "day": el.id});   
            })   
            count=count+1;
          }
      })
      }
      if(kk.length ==0){
        this.service.dangerAlert('Please Upload Video,Image,Document To Create Program');
        this.loading=false;
        return;
      }
      if(userdetail.valid){
        if(userdetail.value.level == undefined){
          userdetail.value.level='';
        }
        if(userdetail.value.gender == undefined){
          userdetail.value.gender='';
        }
        if(type==1){
          this.showView=true;
          this.loading=false;
          this.programData.controls["price"].setValidators([Validators.required,Validators.min(this.amount_min),Validators.max(this.amount_max)]);
          this.programData.controls["price"].updateValueAndValidity();
          window.scroll(0,0);
          this.submitted = false;
        } else {
          this.loading=true;
          if(this.currentUrl=='/edit-program') {
            url='/program-update';
            formdata.append('program_id',this.dataDetail._id);
            formdata.append('status',this.status);  
          } else {
            url="/program";
          } 
        // formdata.append('program_image',this.selectedFile);
        formdata.append('name',userdetail.value.albumName);
        formdata.append('gender', userdetail.value.gender);
        formdata.append('price',userdetail.value.price);
        formdata.append('description',userdetail.value.description);
        formdata.append('videos',JSON.stringify(kk));
        formdata.append('category_type',this.programType);        
        formdata.append('demographic',userdetail.value.demographic);
          if(this.programType==1){
            formdata.append('levels',userdetail.value.level);
            formdata.append('types',this.typename);  
            formdata.append('type_other',userdetail.value.t_others);
          }
          if(this.programType==2){
            formdata.append('diets',userdetail.value.diet);
            formdata.append('categories',this.categoryname);
            formdata.append('sub_categories',this.scategoryname);
            formdata.append('diet_other',userdetail.value.d_others);
            formdata.append('sub_category_other',userdetail.value.s_others); 
          }
          if(this.programType==3){
            formdata.append('levels',userdetail.value.level);
            formdata.append('diets',userdetail.value.diet);
            formdata.append('types',this.typename); 
            formdata.append('categories',this.categoryname); 
            formdata.append('sub_categories',this.scategoryname);
            formdata.append('type_other',userdetail.value.t_others);
            formdata.append('diet_other',userdetail.value.d_others); 
            formdata.append('sub_category_other',userdetail.value.s_others);   
          }
        this.service.PostApiFormData(formdata,url).subscribe(((response:any)=>{
          if(response.success ==1){             
            this.submitted = false;
            if(localStorage.getItem('grw_programTrue')){
              this.loginDetail.program=true;
              localStorage.setItem('grw_login',<any> JSON.stringify(this.loginDetail));
              this.service.setSubject(response.data);
              localStorage.removeItem('grw_programTrue');
            }
            this.router.navigate(['/programs']);
            this.loading=false;
          } else {
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }), (error:any) => {
          this.loading=false;
        });
      }
      } else{
        const invalidControls: string[] = [];
        Object.keys(userdetail.controls).forEach((controlName) => {
          const control = userdetail.get(controlName);
          if (control && control.invalid) {
            invalidControls.push(controlName);
          }
        });
        if(invalidControls.length >1){
          this.service.dangerAlert('Please complete mandatory sections.');
        } else {
          var ss='';
          if(invalidControls[0]=='albumName'){
            ss='Title';
          }
          else if(invalidControls[0]=='types'){
            ss='Product';
          }
          else if(invalidControls[0]=='scategory'){
            ss='Sub category';
          }
         else if(invalidControls[0]=='d_others'){
          ss='Diet Other';
        }
        else if(invalidControls[0]=='t_others'){
          ss='Type Other';
        }
        else if(invalidControls[0]=='price'){
          ss='Price';
        } else if(invalidControls[0]=='description'){
          ss='Description';
        } else {
          ss=invalidControls[0];
  
        }
          this.service.dangerAlert(ss +' is mandatory.');
        }
        this.loading=false;
        userdetail.markAllAsTouched();
        this.scrollToFirstInvalidControl();         
      }
  }


  getUploadFileDetail(event: any) {
      this.selectedFile = event[0];
      var mimeType = event[0].type;
      if (mimeType.match(/image\/*/) == null) {
        this.message = "Only images are supported.";
        return;
      }
      var reader = new FileReader();
      this.imagePath = event;
      reader.readAsDataURL(event[0]);
      reader.onload = (_event:any) => {
        const image = new Image();
        image.src = _event.target.result;
        image.onload = () => {
          const {
            height,
            width
          } = image;
          // if (height < 1080 || width < 1920) {
          //   this.service.dangerAlert("Image should be at least 1920px by 1080px.");
          //   return false;
          // }
          this.imgURL = reader.result;
          return true;        
      };
    }
  }

  changeImage1(event:any ) {
    this.imageChangedEvent = event;
    this.getUploadFileDetail(event.target.files); 
  }

  changeImage(file: any) {
    var mm = "#" + file;
    $(mm).trigger("click");
  }
  
  delete(){
    const url = "/program-delete?program_id="+localStorage.getItem('grw_program_id'); 
    this.service.DeleteApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        $('#DeletePopup2').modal('toggle');
        this.router.navigate(['/programs']);
      }
    }), (error) => { this.loading =false; });
  }

  getalbumDetail(){
    const url = "/program-detail?program_id="+localStorage.getItem('grw_program_id'); 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self=this;
        if(response.data.status=='Published'){
          this.status=1;
        } else {
          if(response.data.status=='Unpublished'){
            this.status=2;
          }
        }
        this.imgURL = response.data.program_image;
        this.croppedImage = response.data.program_image;
        this.programData.controls["types"].setValue(response.data.category_type);
        if(response.data.demographic_info.length != 0){
          response.data.demographic = response.data.demographic_info[0]._id;
        }
        if(response.data.levels_info.length != 0){
          response.data.level = response.data.levels_info[0]._id;
        }
        if(response.data.gender.length != 0){
          response.data.gender = response.data.gender[0]._id;
        }
        if(response.data.type_info.length != 0){
          var ss:any=[];
          response.data.type_info.filter((el:any)=>{
            ss.push(el)
         })
          self.typeSelected=ss;
        }
        if(response.data.diets_info.length != 0){
          response.data.diet = response.data.diets_info[0]._id;
          if(response.data.diets_info[0].childContent){
            self.d_otherSelection=response.data.diets_info[0]._id;
          }
        }
        if(response.data.categories_info.length != 0){
          var mm:any=[];
          response.data.categories_info.filter((el:any)=>{
           mm.push (el);
          })
          self.categorySelected=mm;
        }

        if(response.data.sub_category_info.length != 0){
          var mm1:any=[];
          response.data.sub_category_info.filter((el:any)=>{
           mm1.push (el);
          })
          self.scategorySelected=mm1;
        }
        this.dataDetail = response.data;
        setTimeout(()=>{
          this.AddAlbumData=[];
          var self=this;
          response.data.program_videos.filter((ell:any)=>{
            self.collectDataArray.filter((el:any)=>{
              if(el.id == ell.week_id){
                el.week.day.filter((ells:any)=>{
                  if(ells.id ==ell.day_id){
                    if(ell.week_id ==1 && ell.day_id==1){
                      self.AddAlbumData.push(ell);
                    }
                    if(ell.week_id >1){
                      self.weeknumber=ell.week_id ;
                      self.Weekarray.filter((et:any)=>{
                        if(et.id == ell.week_id){
                          et.dis='';
                        }
                      })
                    }
                    ells.data.push({_id:ell._id,order_number:ell.order_number,alldata:ell});
                  }
                })
              }
            })
          })
          // var kk:any = this.AlbumData;
          // this.AlbumData =[];
          // this.AddAlbumData=[];
         
          // kk.filter((el:any)=>{
          //   var count=0;
          //   response.data.program_videos.filter((ell:any)=>{
          //     if(el._id == ell._id){
          //       count=count+1;
          //     }
          //   })
          //   if(count ==0){
          //     self.AlbumData.push(el);
          //   } else {
          //     self.AddAlbumData.push(el);
          //   }
          // })
          this.weeknumber=1;
          this.daynumber=1;
          this.cdkView = true;
        },200)
      }
     
    }), (error) => { this.loading =false; });
  }

  changeWeek(data:any,type:any){
    this.loading= true;
    var self=this; var count=0;
    if(type==1){
      if(self.weeknumber !=1){
        self.daynumber =1; 
        $('#pills_day_1').trigger('click');
      }
    }
    this.collectDataArray.filter((el:any)=>{
      if(el.id == self.weeknumber){
        el.week.day.filter((ell:any)=>{
          if(ell.data.length !=0){
            if(self.weeknumber < this.Weekarray.length){
            this.Weekarray[self.weeknumber].dis='';
            // this.Weekarray.filter((elm:any)=>{

            //   if(elm.dis=='disabled'){
            //     elm.dis='';
            //     return;
            //   }
            // }) 
            return;
          }
        }
        })
      }
    }) 
     if(this.collectDataArray[this.weeknumber-1].week.day[this.daynumber-1].data.length !=0){
      this.AddAlbumData=[];
      this.collectDataArray[this.weeknumber-1].week.day[this.daynumber-1].data.filter((el:any)=>{
        this.AddAlbumData.push(el.alldata);
      })
      this.loading= false;
    } else {
      this.AddAlbumData=[{}];
      this.loading= false;
    }
     console.log(this.AddAlbumData);

    // var self=this;
    // if(type==1){
    //   var count=0;
    //   this.Weekarray.filter((el:any)=>{
    //     if(count==1){
    //       el.dis ='';
    //       count=0;
    //     }
    //     if(el.id == data.id){
    //       count=count+1;
    //     }                         
    //   })      
    // } else {
    // if(this.collectDataArray[this.weeknumber-1].week.day[this.daynumber-1].data.length !=0){
    //   this.AddAlbumData=[];
    //   this.collectDataArray[this.weeknumber-1].week.day[this.daynumber-1].data.filter((el:any)=>{
    //     this.AddAlbumData.push(el.alldata);
    //   })
    // } else {
    //   this.AddAlbumData=[{}];
    // }
    // }
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    // firstInvalidControl.focus(); //without smooth behavior
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
  
  onDragOver(event:any) {
    event.preventDefault();
  }

// From drag and drop
  onDropSuccess(event:any) {
    this.imageChangedEvent = event;
    event.preventDefault();
    this.getUploadFileDetail(event.dataTransfer.files);    // notice the "dataTransfer" used instead of "target"
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl || event.base64 || '');
    console.log(event);
  }

  imageCropped1(event: any) {
    var reader = new FileReader();
    reader.readAsDataURL(event.blob);
    const self = this;
    reader.onloadend = function () {
      var base64data = reader.result;
      self.croppedImage1 = base64data;
    }
    console.log(self.croppedImage1);
  }

  imageLoaded() {
    this.showCropper = true;
    console.log('Image loaded');
  }

   cropperReady(sourceImageDimensions: Dimensions) {
    console.log('Cropper ready', sourceImageDimensions);
    this.loading = false;
  }

  loadImageFailed() {
    // show message
  }

  setCheckval(event:any){
    this.programType =event.value;
    if(this.programType==1){
      this.d_otherSelection=''; 
      this.programData.controls["d_others"].setValue('');
      this.programData.controls["type"].setValidators([Validators.required]);
      this.programData.controls["type"].updateValueAndValidity();
      this.programData.controls["type"].setValue('');
      this.programData.controls["diet"].removeValidators([Validators.required]);
      this.programData.controls["diet"].updateValueAndValidity();
      this.programData.controls["diet"].setValue('');
      // this.programData.controls["category"].removeValidators([Validators.required]);
      // this.programData.controls["category"].updateValueAndValidity();
      // this.programData.controls["category"].setValue('');
      this.programData.controls["scategory"].removeValidators([Validators.required]);
      this.programData.controls["scategory"].updateValueAndValidity();
      this.programData.controls["scategory"].setValue('');
    } else  if(this.programType==2){
      this.t_otherSelection='';
      this.programData.controls["t_others"].setValue('');
      this.programData.controls["diet"].setValidators([Validators.required]);
      this.programData.controls["diet"].updateValueAndValidity();
      this.programData.controls["diet"].setValue('');
      // this.programData.controls["category"].setValidators([Validators.required]);
      // this.programData.controls["category"].updateValueAndValidity();
      // this.programData.controls["category"].setValue('');
      this.programData.controls["scategory"].setValidators([Validators.required]);
      this.programData.controls["scategory"].updateValueAndValidity();
      this.programData.controls["scategory"].setValue('');
      this.programData.controls["type"].removeValidators([Validators.required]);
      this.programData.controls["type"].updateValueAndValidity();
      this.programData.controls["type"].setValue('');
    } else {
      this.programData.controls["diet"].setValidators([Validators.required]);
      this.programData.controls["diet"].updateValueAndValidity();
      this.programData.controls["diet"].setValue('');
      // this.programData.controls["category"].setValidators([Validators.required]);
      // this.programData.controls["category"].updateValueAndValidity();
      // this.programData.controls["category"].setValue('');
      this.programData.controls["scategory"].setValidators([Validators.required]);
      this.programData.controls["scategory"].updateValueAndValidity();
      this.programData.controls["scategory"].setValue('');
      this.programData.controls["type"].setValidators([Validators.required]);
      this.programData.controls["type"].updateValueAndValidity();
      this.programData.controls["type"].setValue('');
    }
    this.AddAlbumData = [{}];
    this.getDetail1();
  }

  updateStatus(){
    var url="/program-update-status?program_id=" +localStorage.getItem('grw_program_id');
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success){
        this.service.successAlert(response.message);  
        this.getalbumDetail();    
      } else {
        this.service.dangerAlert(response.message);   
      }
    }))
    }

    getAllMasterData(){  
      var self=this,ss:any=[],dd:any=[];
      const url = "/common-contents"; 
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {   
          this.allmasterData=response.data;
          this.allmasterData.type.filter((el:any)=>{
            if(el.childContent==false){
              ss.push(el);
            } else {
              dd=el;
            }
            el.chcecked = false;
          });
          ss.push(dd);
          this.allmasterData.type =ss;
          ss=[],dd=[]; 
          this.allmasterData.sub_category.filter((el:any)=>{
            if(el.childContent==false){
              ss.push(el);
            } else {
              dd=el;
            }
            el.chcecked = false;
          });
          ss.push(dd);
          this.allmasterData.sub_category =ss;
          ss=[],dd=[];
          this.allmasterData.diet.filter((el:any)=>{
            if(el.childContent==false){
              ss.push(el);
            } else {
              dd=el;
            }
            el.chcecked = false;
          })
          ss.push(dd);
          this.allmasterData.diet =ss;
          ss=[],dd=[];   
      this.sprimaryList = this.allmasterData.sub_category;  
      this.primaryList = this.allmasterData.primary_category;   
      this.demographicList =this.allmasterData.demographic;
      this.LevelLIst = this.allmasterData.levels;
      this.dietList = this.allmasterData.diet; 
      this.TypeList = this.allmasterData.type; 
      // this.allmasterData.genders.filter((el:any)=>{
      //   if(el.name!='Other' && el.name!='other'){
      //     ss.push(el);
      //   } else {
      //     dd=el;
      //   }
      //   el.chcecked = false;
      // })
      // ss.push(dd);
      // this.allmasterData.genders =ss;
      ss=[],dd=[];
      this.genderList = this.allmasterData.genders;
    }
  }), (error) => { this.loading =false; });
    }

    onFilterChange(event: any, type: any) {
      if (type == 1) {
      } else if (type == 2) {
      } else if (type == 3) {
      } else if (type == 4) {
      } else {
      }
      console.log(event);
    }
  
    changeSelection(type:any) {
      var subcatText: any='',self=this,count=0;
      if(type==1){
        if (this.typeSelected.length != 0) {
          this.typeSelected.filter(function (ell: any) {          
            if (subcatText) {
              subcatText = ell._id + " , " + subcatText;
            } else {
              subcatText = ell._id;
            }      
          });
          if(subcatText !=''){
            this.typename= subcatText;
          }
          this.typeSelected.filter(function (ell: any) {
            self.TypeList.filter((el:any)=>{
              if(ell._id ==el._id && el.childContent==true){
                count=1;
              }            
            })               
          });
          if(count==1){
            self.t_otherSelection ='123344';
            self.programData.controls["t_others"].setValidators([Validators.required]);
            self.programData.controls["t_others"].updateValueAndValidity();
            // self.programData.controls["t_others"].setValue('');
          } else {
            self.t_otherSelection ='';
            self.programData.controls["t_others"].removeValidators([Validators.required]);
            self.programData.controls["t_others"].updateValueAndValidity();
            self.programData.controls["t_others"].setValue('');
          }
        }
      } else if(type==2){
        if (this.categorySelected.length != 0) {
          this.categorySelected.filter(function (el: any) {
            if (subcatText) {
              subcatText = el._id + " , " + subcatText;
            } else {
              subcatText = el._id;
            }       
          });        
          if(subcatText !=''){
            this.categoryname= subcatText;
          }
        } else {
          this.categoryname='';
        }
      } else{
        if (this.scategorySelected.length != 0) {        
          this.scategorySelected.filter(function (ell: any) {         
            if (subcatText) {
              subcatText = ell._id + " , " + subcatText;
            } else {
              subcatText = ell._id;
            }       
          });        
          if(subcatText !=''){
            this.scategoryname= subcatText;
          }
          this.scategorySelected.filter(function (ell: any) {
            self.sprimaryList.filter((el:any)=>{
              if(ell._id ==el._id && el.childContent==true){
               count=1
              }             
            })                 
          }); 
          if(count==1){
            self.s_otherSelection ='123344';
            self.programData.controls["s_others"].setValidators([Validators.required]);
            self.programData.controls["s_others"].updateValueAndValidity();
            self.programData.controls["s_others"].setValue('');
          } else {
            self.s_otherSelection ='';
            self.programData.controls["s_others"].removeValidators([Validators.required]);
            self.programData.controls["s_others"].updateValueAndValidity();
            self.programData.controls["s_others"].setValue('');
          }
        }
      }
  
    }


    getCheckboxexData(event:any){
      var self=this;
        this.dietList.filter((el:any)=>{
            if(event.value ==el._id && el.childContent==true){
              self.d_otherSelection =el._id;
              self.programData.controls["d_others"].setValidators([Validators.required]);
              self.programData.controls["d_others"].updateValueAndValidity();
              // self.programData.controls["d_others"].setValue('');
            } 
            if(event.value ==el._id && el.childContent==false){
              self.d_otherSelection ='';
              self.programData.controls["d_others"].removeValidators([Validators.required]);
              self.programData.controls["d_others"].updateValueAndValidity();
              self.programData.controls["d_others"].setValue('');
            } 
            if(el._id == event.value){
              el.chcecked = true;
            } else {
              el.chcecked = false;
            }                 
        })   
    }

    getChaecks(event:any){
      var self=this;
      this.genderList.filter((el:any)=>{
        if(el._id == event.target.id){
          if(el.chcecked==true){
            $("#"+event.target.id).prop("checked", false); 
            el.chcecked=false;
            self.programData.controls['gender'].setValue('');
          } else {
            $("#"+event.target.id).prop("checked", true); 
            el.chcecked=true;
          }
        } else {
          el.checked=false;
        }
      })

    }
}
